import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { WarrantiesService } from 'src/app/pages/dashboards/service/warranties.service';
import { IssueWarrantyDTO, RequestPutWarrantieBuild } from 'src/app/pages/dashboards/warranties/interfaces/warranty.interface';

@Component({
  selector: 'app-modal-warrantie-is-build',
  templateUrl: './modal-warrantie-is-build.component.html',
  styleUrl: './modal-warrantie-is-build.component.scss'
})
export class ModalWarrantieIsBuildComponent {
  public formUpdate: FormGroup;
  public estados = [{value:true, text:'Si'},{value:false, text:'No'}];
  public garantia: IssueWarrantyDTO;
  public list: RequestPutWarrantieBuild[] = []; 

  constructor(private dialogRef: MatDialogRef<ModalWarrantieIsBuildComponent>, private fb: FormBuilder, private warrantiesService: WarrantiesService, @Inject(MAT_DIALOG_DATA)public data: any )
  {
    this.garantia = data;
    this.formUpdate = this.fb.group({
      state: new FormControl(data.isBuild, [Validators.required])
    });
  }

  ngOnInit(): void {

  }

  public submit() {
    const {state} = this.formUpdate.value;

    const requestBody = {
      warrantyId: this.garantia.warrantyId,
      isConstruccion: state
    };

    this.list.push(requestBody);

    this.warrantiesService.putWarrantiesBuild(this.list).subscribe({
      next:(res) =>{
        Swal.fire({
          title: 'Operación exitosa',
          text: res.message,
          icon: 'success',
          showConfirmButton: true,
          confirmButtonText: 'Cerrar'
        }).then((r) => {
          if(r.isConfirmed) {
            this.dialogRef.close(true);
          }
        })
      },
      error: (err) => {
        Swal.fire({
          title: 'Operación fallida',
          text: err.error.resultMessage || 'Ha ocurrido un error inesperado',
          icon: 'error',
          showConfirmButton: true,
          confirmButtonText: 'Cerrar'
        })
      }
    })
  }

}